import sandy from './assets/woofers/sandy.png'
import blue from './assets/woofers/blue.png'
import burg from './assets/woofers/burg.png'
import night from './assets/woofers/night.png'
import terrier from './assets/woofers/skin/terrier.png'
import labrador from './assets/woofers/skin/labrador.png'
import retriever from './assets/woofers/skin/retriever.png'
import beagle from './assets/woofers/skin/beagle.png'
import ridgeback from './assets/woofers/skin/ridgeback.png'
import doberman from './assets/woofers/skin/doberman.png'
import alaskan from './assets/woofers/skin/alaskan.png'
import golden from './assets/woofers/skin/golden.png'
import woof from './assets/woofers/skin/woof100.png'
import skeleton from './assets/woofers/skin/skeleton.png'
import bluesnap from './assets/woofers/head/bluesnap.png'
import blacksnap from './assets/woofers/head/blacksnap.png'
import fedora from './assets/woofers/head/fedora.png'
import redbeanie from './assets/woofers/head/redbeanie.png'
import blackbeanie from './assets/woofers/head/blackbeanie.png'
import bandana from './assets/woofers/head/bandana.png'
import tophat from './assets/woofers/head/tophat.png'
import pirate from './assets/woofers/head/pirate.png'
import outlaw from './assets/woofers/head/outlaw.png'
import bulb from './assets/woofers/head/bulp.png'
import cowboy from './assets/woofers/head/cowboy.png'
import copter from './assets/woofers/head/copter.png'
import chef from './assets/woofers/head/chef.png'
import captain from './assets/woofers/head/captain.png'
import knight from './assets/woofers/head/knight.png'
import rasta from './assets/woofers/head/rasta.png'
import tiara from './assets/woofers/head/tiara.png'
import crown from './assets/woofers/head/crown.png'
import santahat from './assets/woofers/head/santahat.png'
import horns from './assets/woofers/head/horns.png'
import solsnap from './assets/woofers/head/solsnap.png'
import antlers from './assets/woofers/head/antlers.png'
import islandboys from './assets/woofers/head/islandboys.png'
import hokage from './assets/woofers/head/ninja.png'
import astronaut from './assets/woofers/head/astronaut.png'
import glasses from './assets/woofers/eyes/glasses.png'
import roundglasses from './assets/woofers/eyes/roundglasses.png'
import sunglasses from './assets/woofers/eyes/sunglasses.png'
import goggles from './assets/woofers/eyes/goggles.png'
import makeup from './assets/woofers/eyes/makeup.png'
import bandit from './assets/woofers/eyes/bandit.png'
import stoned from './assets/woofers/eyes/stoned.png'
import snekeyes from './assets/woofers/eyes/snekeyes.png'
import hearteyes from './assets/woofers/eyes/hearteyes.png'
import eyepatch from './assets/woofers/eyes/eyepatch.png'
import monocle from './assets/woofers/eyes/monocle.png'
import redviper from './assets/woofers/eyes/redviper.png'
import scouter from './assets/woofers/eyes/scouter.png'
import greenviper from './assets/woofers/eyes/greenviper.png'
import robolens from './assets/woofers/eyes/robolens.png'
import lasereyes from './assets/woofers/eyes/lasereyes.png'
import solanaviper from './assets/woofers/eyes/solanaviper.png'
import redshirt from './assets/woofers/clothing/redshirt.png'
import tanktop from './assets/woofers/clothing/tanktop.png'
import woolsweater from './assets/woofers/clothing/woolsweater.png'
import redcollar from './assets/woofers/clothing/redcollar.png'
import spikedcollar from './assets/woofers/clothing/spikedcollar.png'
import polo from './assets/woofers/clothing/poloshirt.png'
import striped from './assets/woofers/clothing/striped.png'
import whiteshirt from './assets/woofers/clothing/whiteshirt.png'
import icy from './assets/woofers/clothing/icy.png'
import emerald from './assets/woofers/clothing/emerald.png'
import diamond from './assets/woofers/clothing/diamond.png'
import reptile from './assets/woofers/clothing/reptile.png'
import referee from './assets/woofers/clothing/referee.png'
import chain from './assets/woofers/clothing/chain.png'
import suit from './assets/woofers/clothing/suit.png'
import cowboycloth from './assets/woofers/clothing/cowboy.png'
import greenhoodie from './assets/woofers/clothing/greenhoodie.png'
import blackhoodie from './assets/woofers/clothing/blackhoodie.png'
import santasuit from './assets/woofers/clothing/santa.png'
import hokagecloth from './assets/woofers/clothing/hokage.png'
import cape from './assets/woofers/clothing/cape.png'
import astronautcloth from './assets/woofers/clothing/astronaut.png'
import tongue from './assets/woofers/mouth/tongue.png'
import cigarette from './assets/woofers/mouth/cigarette.png'
import joint from './assets/woofers/mouth/joint.png'
import cigar from './assets/woofers/mouth/cigar.png'
import lipstick from './assets/woofers/mouth/lipstick.png'
import bigsmile from './assets/woofers/mouth/bigsmile.png'
import rednose from './assets/woofers/mouth/rednose.png'
import rabbit from './assets/woofers/mouth/rabbit.png'
import covidmask from './assets/woofers/mouth/covidmarket.png'
import bubblegum from './assets/woofers/mouth/bubblegum.png'
import moustache from './assets/woofers/mouth/moustache.png'
import bandanamouth from './assets/woofers/mouth/bandana.png'
import pipe from './assets/woofers/mouth/pipe.png'
import robomouth from './assets/woofers/mouth/robomouth.png'
import grillz from './assets/woofers/mouth/grillz.png'

export type WooferAttributeKey =
    | 'background'
    | 'mouth'
    | 'eyes'
    | 'clothing'
    | 'skin'
    | 'head'

export const attributes = {
    background: {
        label: 'Background',
        items: [
            {
                text: 'Sandy Gold',
                key: 'sgbg',
                fact: 'common',
                color: '#949494',
                image: sandy,
                rarity: '50.00%',
            },
            {
                text: 'East Bay Blue',
                key: 'ebbg',
                fact: 'uncommon',
                color: '#20d58a',
                image: blue,
                rarity: '40.00%',
            },
            {
                text: 'Burgundy',
                key: 'bbg',
                fact: 'epic',
                color: '#9901f6',
                image: burg,
                rarity: '9.00%',
            },
            {
                text: 'Night Sky',
                key: 'nsbg',
                fact: 'mythic',
                color: '#ed2939',
                image: night,
                rarity: '1.00%',
            },
        ],
    },
    skin: {
        label: 'Skin / Breed',
        items: [
            {
                text: 'Terrier',
                key: 'ts',
                fact: 'common',
                color: '#949494',
                image: terrier,
                rarity: '30.00%',
            },
            {
                text: 'Labrador',
                key: 'ls',
                fact: 'common',
                color: '#949494',
                image: labrador,
                rarity: '25.00%',
            },
            {
                text: 'Retriever',
                key: 'rs',
                fact: 'uncommon',
                color: '#20d58a',
                image: retriever,
                rarity: '15.00%',
            },
            {
                text: 'Beagle',
                key: 'bgs',
                fact: 'rare',
                color: '#00b3ff',
                image: beagle,
                rarity: '8.00%',
            },
            {
                text: 'Ridgeback',
                key: 'rbs',
                fact: 'rare',
                color: '#00b3ff',
                image: ridgeback,
                rarity: '7.00%',
            },
            {
                text: 'Doberman',
                key: 'dbs',
                fact: 'rare',
                color: '#00b3ff',
                image: doberman,
                rarity: '6.00%',
            },
            {
                text: 'Alaskan',
                key: 'as',
                fact: 'epic',
                color: '#9901f6',
                image: alaskan,
                rarity: '5.00%',
            },
            {
                text: 'Golden',
                key: 'gs',
                fact: 'legendary',
                color: '#ff8101',
                image: golden,
                rarity: '2.50%',
            },
            {
                text: 'Woof',
                key: 'ws',
                fact: 'legendary',
                color: '#ff8101',
                image: woof,
                rarity: '1.00%',
            },
            {
                text: 'Skeleton',
                key: 'ss',
                fact: 'mythic',
                color: '#ed2939',
                image: skeleton,
                rarity: '0.50%',
            },
        ],
    },
    head: {
        label: 'Head',
        items: [
            {
                text: 'None',
                key: 'nh',
                fact: 'common',
                color: '#949494',
                image: null,
                rarity: '24.00%',
            },
            {
                text: 'Blue Snapback',
                key: 'bsh',
                fact: 'common',
                color: '#949494',
                image: bluesnap,
                rarity: '8.80%',
            },
            {
                text: 'Black Snapback',
                key: 'blsh',
                fact: 'common',
                color: '#949494',
                image: blacksnap,
                rarity: '8.80%',
            },
            {
                text: 'Fedora',
                key: 'fh',
                fact: 'uncommon',
                color: '#20d58a',
                image: fedora,
                rarity: '5.80%',
            },
            {
                text: 'Red Beanie',
                key: 'rbh',
                fact: 'uncommon',
                color: '#20d58a',
                image: redbeanie,
                rarity: '5.30%',
            },
            {
                text: 'Black Beanie',
                key: 'bbh',
                fact: 'uncommon',
                color: '#20d58a',
                image: blackbeanie,
                rarity: '5.20%',
            },
            {
                text: 'Bandana',
                key: 'bdh',
                fact: 'rare',
                color: '#00b3ff',
                image: bandana,
                rarity: '4.50%',
            },
            {
                text: 'TopHat',
                key: 'thh',
                fact: 'rare',
                color: '#00b3ff',
                image: tophat,
                rarity: '4.50%',
            },
            {
                text: 'Pirate',
                key: 'ph',
                fact: 'rare',
                color: '#00b3ff',
                image: pirate,
                rarity: '3.70%',
            },
            {
                text: 'Outlaw',
                key: 'oh',
                fact: 'epic',
                color: '#9901f6',
                image: outlaw,
                rarity: '3.50%',
            },
            {
                text: 'Light Bulbs',
                key: 'lh',
                fact: 'epic',
                color: '#9901f6',
                image: bulb,
                rarity: '3.40%',
            },
            {
                text: 'Cowboy',
                key: 'ch',
                fact: 'epic',
                color: '#9901f6',
                image: cowboy,
                rarity: '3.20%',
            },
            {
                text: "Copter's Hat",
                key: 'csh',
                fact: 'epic',
                color: '#9901f6',
                image: copter,
                rarity: '2.90%',
            },
            {
                text: 'Chef',
                key: 'cheh',
                fact: 'epic',
                color: '#9901f6',
                image: chef,
                rarity: '2.80%',
            },
            {
                text: "Captain's Hat",
                key: 'caph',
                fact: 'epic',
                color: '#9901f6',
                image: captain,
                rarity: '2.70%',
            },
            {
                text: 'Knight',
                key: 'kh',
                fact: 'epic',
                color: '#9901f6',
                image: knight,
                rarity: '2.50%',
            },
            {
                text: 'Rastafarian',
                key: 'rh',
                fact: 'legendary',
                color: '#ff8101',
                image: rasta,
                rarity: '1.00%',
            },
            {
                text: 'Tiara',
                key: 'th',
                fact: 'legendary',
                color: '#ff8101',
                image: tiara,
                rarity: '1.00%',
            },
            {
                text: 'Crown',
                key: 'croh',
                fact: 'legendary',
                color: '#ff8101',
                image: crown,
                rarity: '1.00%',
            },
            {
                text: 'Santa Hat',
                key: 'sanh',
                fact: 'legendary',
                color: '#ff8101',
                image: santahat,
                rarity: '1.00%',
            },
            {
                text: 'Horns',
                key: 'horh',
                fact: 'legendary',
                color: '#ff8101',
                image: horns,
                rarity: '1.00%',
            },
            {
                text: 'SOL Snapback',
                key: 'ssh',
                fact: 'legendary',
                color: '#ff8101',
                image: solsnap,
                rarity: '1.00%',
            },
            {
                text: 'Antlers',
                key: 'anh',
                fact: 'mythic',
                color: '#ed2939',
                image: antlers,
                rarity: '0.50%',
            },
            {
                text: 'Island Boy',
                key: 'ibh',
                fact: 'mythic',
                color: '#ed2939',
                image: islandboys,
                rarity: '0.50%',
            },
            {
                text: 'Hokage',
                key: 'hh',
                fact: 'mythic',
                color: '#ed2939',
                image: hokage,
                rarity: '0.50%',
            },
            {
                text: 'Astronaut',
                key: 'asth',
                fact: 'mythic',
                color: '#ed2939',
                image: astronaut,
                rarity: '0.50%',
            },
        ],
    },
    eyes: {
        label: 'Eyes',
        items: [
            {
                text: 'None',
                key: 'ne',
                fact: 'common',
                color: '#949494',
                image: null,
                rarity: '35.00%',
            },
            {
                text: 'Glasses',
                key: 'ge',
                fact: 'common',
                color: '#949494',
                image: glasses,
                rarity: '9.30%',
            },
            {
                text: 'Round Glasses',
                key: 'rge',
                fact: 'common',
                color: '#949494',
                image: roundglasses,
                rarity: '7.50%',
            },
            {
                text: 'Sunglasses',
                key: 'sge',
                fact: 'common',
                color: '#949494',
                image: sunglasses,
                rarity: '7.30%',
            },
            {
                text: 'Goggles',
                key: 'gge',
                fact: 'common',
                color: '#949494',
                image: goggles,
                rarity: '7.30%',
            },
            {
                text: 'Make-Up',
                key: 'me',
                fact: 'uncommon',
                color: '#20d58a',
                image: makeup,
                rarity: '5.50%',
            },
            {
                text: 'Bandit Mask',
                key: 'bme',
                fact: 'uncommon',
                color: '#20d58a',
                image: bandit,
                rarity: '5.50%',
            },
            {
                text: 'Stoned',
                key: 'ste',
                fact: 'rare',
                color: '#00b3ff',
                image: stoned,
                rarity: '3.10%',
            },
            {
                text: 'Snek Eyes',
                key: 'sne',
                fact: 'rare',
                color: '#00b3ff',
                image: snekeyes,
                rarity: '3.00%',
            },
            {
                text: 'Heart Eyes',
                key: 'he',
                fact: 'epic',
                color: '#9901f6',
                image: hearteyes,
                rarity: '2.70%',
            },
            {
                text: 'Eyepatch',
                key: 'epe',
                fact: 'epic',
                color: '#9901f6',
                image: eyepatch,
                rarity: '2.60%',
            },
            {
                text: 'Monocle',
                key: 'mone',
                fact: 'epic',
                color: '#9901f6',
                image: monocle,
                rarity: '2.50%',
            },
            {
                text: 'Red Vipers',
                key: 'rve',
                fact: 'epic',
                color: '#9901f6',
                image: redviper,
                rarity: '2.40%',
            },
            {
                text: 'Scouter',
                key: 'sce',
                fact: 'legendary',
                color: '#ff8101',
                image: scouter,
                rarity: '2.00%',
            },
            {
                text: 'Green Viper',
                key: 'gve',
                fact: 'legendary',
                color: '#ff8101',
                image: greenviper,
                rarity: '2.00%',
            },
            {
                text: 'Robo Lens',
                key: 'rle',
                fact: 'legendary',
                color: '#ff8101',
                image: robolens,
                rarity: '1.00%',
            },
            {
                text: 'Laser Eyes',
                key: 'le',
                fact: 'mythic',
                color: '#ed2939',
                image: lasereyes,
                rarity: '0.50%',
            },
            {
                text: 'SOL Vipers',
                key: 'solve',
                fact: 'mythic',
                color: '#ed2939',
                image: solanaviper,
                rarity: '0.50%',
            },
        ],
    },
    clothing: {
        label: 'Clothing',
        items: [
            {
                text: 'None',
                key: 'nc',
                fact: 'common',
                color: '#949494',
                image: null,
                rarity: '20.00%',
            },
            {
                text: 'Red T-Shirt',
                key: 'rsc',
                fact: 'common',
                color: '#949494',
                image: redshirt,
                rarity: '12.00%',
            },
            {
                text: 'Tank Top',
                key: 'ttc',
                fact: 'common',
                color: '#949494',
                image: tanktop,
                rarity: '12.00%',
            },
            {
                text: 'Wool Sweater',
                key: 'wsc',
                fact: 'uncommon',
                color: '#20d58a',
                image: woolsweater,
                rarity: '8.00%',
            },
            {
                text: 'Red Collar',
                key: 'rcc',
                fact: 'uncommon',
                color: '#20d58a',
                image: redcollar,
                rarity: '7.00%',
            },
            {
                text: 'Spiked Collar',
                key: 'scc',
                fact: 'rare',
                color: '#00b3ff',
                image: spikedcollar,
                rarity: '5.50%',
            },
            {
                text: 'Polo',
                key: 'pc',
                fact: 'rare',
                color: '#00b3ff',
                image: polo,
                rarity: '5.00%',
            },
            {
                text: 'Stripped Shirt',
                key: 'ssc',
                fact: 'rare',
                color: '#00b3ff',
                image: striped,
                rarity: '5.00%',
            },
            {
                text: 'White Shirt & Chain',
                key: 'wscc',
                fact: 'rare',
                color: '#00b3ff',
                image: whiteshirt,
                rarity: '5.00%',
            },
            {
                text: 'Icy Chain',
                key: 'icc',
                fact: 'epic',
                color: '#9901f6',
                image: icy,
                rarity: '3.00%',
            },
            {
                text: 'Emerald Necklace',
                key: 'enc',
                fact: 'epic',
                color: '#9901f6',
                image: emerald,
                rarity: '3.00%',
            },
            {
                text: 'Diamond Necklace',
                key: 'dnc',
                fact: 'epic',
                color: '#9901f6',
                image: diamond,
                rarity: '3.00%',
            },
            {
                text: 'Reptile',
                key: 'repc',
                fact: 'epic',
                color: '#9901f6',
                image: reptile,
                rarity: '2.50%',
            },
            {
                text: 'Referee',
                key: 'refc',
                fact: 'epic',
                color: '#9901f6',
                image: referee,
                rarity: '2.50%',
            },
            {
                text: 'Gold Chain',
                key: 'golc',
                fact: 'epic',
                color: '#9901f6',
                image: chain,
                rarity: '2.50%',
            },
            {
                text: 'Suit',
                key: 'suitc',
                fact: 'legendary',
                color: '#ff8101',
                image: suit,
                rarity: '2.00%',
            },
            {
                text: 'Cowboy',
                key: 'cowc',
                fact: 'legendary',
                color: '#ff8101',
                image: cowboycloth,
                rarity: '2.00%',
            },
            {
                text: 'Green Hoodie',
                key: 'ghc',
                fact: 'legendary',
                color: '#ff8101',
                image: greenhoodie,
                rarity: '1.00%',
            },
            {
                text: 'Black Hoodie',
                key: 'bhc',
                fact: 'legendary',
                color: '#ff8101',
                image: blackhoodie,
                rarity: '1.00%',
            },
            {
                text: 'Santa Suit',
                key: 'sanc',
                fact: 'mythic',
                color: '#ed2939',
                image: santasuit,
                rarity: '0.50%',
            },
            {
                text: 'Hokage',
                key: 'hc',
                fact: 'mythic',
                color: '#ed2939',
                image: hokagecloth,
                rarity: '0.50%',
            },
            {
                text: 'Cape',
                key: 'cc',
                fact: 'mythic',
                color: '#ed2939',
                image: cape,
                rarity: '0.50%',
            },
            {
                text: 'Astronaut',
                key: 'astc',
                fact: 'mythic',
                color: '#ed2939',
                image: astronautcloth,
                rarity: '0.50%',
            },
        ],
    },
    mouth: {
        label: 'Mouth',
        items: [
            {
                text: 'None',
                key: 'nm',
                fact: 'common',
                color: '#949494',
                image: null,
                rarity: '20.00%',
            },
            {
                text: 'Tongue',
                key: 'tm',
                fact: 'common',
                color: '#949494',
                image: tongue,
                rarity: '15.00%',
            },
            {
                text: 'Cigarette',
                key: 'cm',
                fact: 'common',
                color: '#949494',
                image: cigarette,
                rarity: '12.00%',
            },
            {
                text: 'Joint',
                key: 'jm',
                fact: 'uncommon',
                color: '#20d58a',
                image: joint,
                rarity: '5.50%',
            },
            {
                text: 'Cigar',
                key: 'cigm',
                fact: 'uncommon',
                color: '#20d58a',
                image: cigar,
                rarity: '4.50%',
            },
            {
                text: 'Lipstick',
                key: 'lsm',
                fact: 'rare',
                color: '#00b3ff',
                image: lipstick,
                rarity: '4.00%',
            },
            {
                text: 'Big Smile',
                key: 'bsm',
                fact: 'rare',
                color: '#00b3ff',
                image: bigsmile,
                rarity: '3.50%',
            },
            {
                text: 'Red Nose',
                key: 'rnm',
                fact: 'rare',
                color: '#00b3ff',
                image: rednose,
                rarity: '3.00%',
            },
            {
                text: 'Rabbit Teeth',
                key: 'rtm',
                fact: 'epic',
                color: '#9901f6',
                image: rabbit,
                rarity: '2.06%',
            },
            {
                text: 'Covid Mask',
                key: 'cmm',
                fact: 'epic',
                color: '#9901f6',
                image: covidmask,
                rarity: '2.06%',
            },
            {
                text: 'Bubblegum',
                key: 'bgm',
                fact: 'epic',
                color: '#9901f6',
                image: bubblegum,
                rarity: '2.06%',
            },
            {
                text: 'Moustache',
                key: 'mm',
                fact: 'legendary',
                color: '#ff8101',
                image: moustache,
                rarity: '1.70%',
            },
            {
                text: 'Bandana',
                key: 'bm',
                fact: 'legendary',
                color: '#ff8101',
                image: bandanamouth,
                rarity: '1.50%',
            },
            {
                text: 'Pipe',
                key: 'pm',
                fact: 'legendary',
                color: '#ff8101',
                image: pipe,
                rarity: '1.50%',
            },
            {
                text: 'Robo Mask',
                key: 'rmm',
                fact: 'mythic',
                color: '#ed2939',
                image: robomouth,
                rarity: '0.36%',
            },
            {
                text: 'Grillz',
                key: 'gm',
                fact: 'mythic',
                color: '#ed2939',
                image: grillz,
                rarity: '0.18%',
            },
        ],
    },
}
